import React from "react";
import styles from "./Header.module.scss";
import {withRouter} from 'react-router-dom';
import imgLogo from "../../../assets/images/logo.png";
import img2Logo from "../../../assets/images/logo2.png";

const Header = props => {
  const toHome = () => {
    props.history.push('/')
  }
  return <div className={styles.logoContainer}>
    <img
      src={imgLogo}
      onClick={toHome}
      alt="NSW Government"
      className={styles.logo}
    />
    <img
      src={img2Logo}
      onClick={toHome}
      alt="ANZ"
      className={styles.logo2}
    />
  </div>
};

export default withRouter(props => <Header {...props}/>);
